export class OrderFields {
    public static fields = [
        { label: 'Цена', value: 'cost/CalculationWeight' },
        { label: 'Калории', value: 'CalorificValue' },
        { label: 'Белки', value: 'Proteins' },
        { label: 'Жиры', value: 'Fats' },
        { label: 'Углеводы', value: 'Carbohydrates' },
        { label: 'Название', value: 'FullName' },
        { label: 'Дата публикации', value: 'TimeFrom' },
        { label: 'Рейтинг', value: 'RatingMenu' }
    ];
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/OrderFields.ts